export type PortalType =
  | "BOOKING_KIT"
  | "REGIONDO"
  | "PALISIS"
  | "GET_YOUR_GUIDE"
  | "INSIDE"
  | "CIAO_FLORENCE";

export const MANUAL_PORTALS: PortalType[] = ["GET_YOUR_GUIDE", "INSIDE", "CIAO_FLORENCE"];

export interface SettingEvent {
  id?: number;
  portal: PortalType;
  idEvent: string;
  idProdottoBds: number | null;
  idPartenzaBds: number | null;
  idPartenzaEvent: string | null;
  isActive: boolean;
  isEdit?: boolean;
}

export interface SettingEventsResponse {
  settingsEvent: SettingEvent[];
  bdsEvents: BdsEvent[];
  externalEvents: ExternalEvent[];
}

export interface BdsEvent {
  id: number;
  name: string;
  partenze: BdsPartenza[];
}

export interface BdsPartenza {
  id: number;
  name: string;
}

export interface ExternalEvent {
  portal: PortalType;
  id: string;
  name: string;
}

export const PORTAL_LABELS: Record<PortalType, string> = {
  BOOKING_KIT: "Booking Kit",
  REGIONDO: "Regiondo",
  PALISIS: "Palisis",
  GET_YOUR_GUIDE: "GetYourGuide",
  INSIDE: "Inside.com",
  CIAO_FLORENCE: "CiaoFlorence",
};

export interface SettingPortalResponse {
  portal: PortalType;
  isActive: boolean;
}
